/**
 * PostMessage utility functions for cross-window communication
 */

/**
 * Check if message origin is valid
 * @param {string} eventOrigin - Origin of the message event
 * @param {string} currentOrigin - Current window origin
 * @param {string[]} allowedOrigins - Array of allowed origins (for test environments)
 * @returns {boolean}
 */
export function isValidMessageOrigin(eventOrigin, currentOrigin, allowedOrigins = []) {
  // Same origin
  if (eventOrigin === currentOrigin) {
    return true
  }
  
  // Check allowed origins (for test environments)
  return allowedOrigins.some(allowed => 
    eventOrigin === allowed || eventOrigin.includes(allowed)
  )
}

/**
 * Check if current window is a popup window
 * @returns {boolean}
 */
export function isPopupWindow() {
  return window.opener && !window.opener.closed
}

/**
 * Send postMessage to parent window
 * @param {string} type - Message type
 * @param {Object} payload - Message payload
 * @param {number} closeDelay - Delay before closing popup (ms)
 * @returns {boolean} - Returns true if message was sent, false otherwise
 */
export function sendMessageToParent(type, payload, closeDelay = 500) {
  if (!isPopupWindow()) {
    return false
  }
  
  const targetOrigin = window.location.origin
  const message = { type, ...payload }
  
  window.opener.postMessage(message, targetOrigin)
  
  // Close popup after message is sent
  setTimeout(() => {
    window.close()
  }, closeDelay)
  
  return true
}
